import { render, staticRenderFns } from "./set-hrs.vue?vue&type=template&id=1260bc61&scoped=true&lang=pug&"
import script from "./set-hrs.vue?vue&type=script&lang=js&"
export * from "./set-hrs.vue?vue&type=script&lang=js&"
import style0 from "./set-hrs.vue?vue&type=style&index=0&id=1260bc61&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1260bc61",
  null
  
)

export default component.exports